import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
    createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';

import * as chanceApi from '../../lib/api/chance';

const [
    LIST_PROJECT_TECH_FILES,
    LIST_PROJECT_TECH_FILES_SUCCESS,
    LIST_PROJECT_TECH_FILES_FAILURE,
] = createRequestActionTypes('project/LIST_PROJECT_TECH_FILES');

export const listProjectTechFiles = createAction(
    LIST_PROJECT_TECH_FILES,
    (fileTyp, fileAttrVal1) => ({ fileTyp, fileAttrVal1 }),
);
const listProjectTechFilesSaga = createRequestSaga(
    LIST_PROJECT_TECH_FILES,
    chanceApi.getChanceFiles,
);

const UNLOAD_TECH_FILES = 'project/UNLOAD_TECH_FILES';
export const unloadTechFiles = createAction(UNLOAD_TECH_FILES);

export function* projectTechFilesSaga() {
    yield takeLatest(LIST_PROJECT_TECH_FILES, listProjectTechFilesSaga);
}

const initialState = {
    files: null,
    error: null,
};

const projectTechFiles = handleActions(
    {
        [LIST_PROJECT_TECH_FILES_SUCCESS]: (state, { payload: data }) => ({
            ...state,
            files: data.list.map((file) => ({
                id: file.fileUuid,
                fileUrl: file.fileUrl,
                fileTyp: file.fileTyp,
                fileAttrVal1: file.fileAttrVal1, //prjUuid
                fileAttrVal2: file.fileAttrVal2,
                fileAttrVal3: file.fileAttrVal3,
                fileNm: file.fileNm,
                fileDesc: file.fileDesc,
                crtNm: file.crtNm,
                crtDt: file.crtDt,
                cngNm: file.cngNm,
                cngDt: file.cngDt,
            })),
            error: null,
        }),
        [LIST_PROJECT_TECH_FILES_FAILURE]: (state, { payload: error }) => ({
            ...state,
            error: error,
        }),
        [UNLOAD_TECH_FILES]: () => initialState,
    },
    initialState,
);

export default projectTechFiles;
